import { isFreeProfessional } from '@/utils/resources/auth/authResource';
import { isCanUseProfessionalProffit, isProfessionalPreStatus, } from '@/utils/resources/profile/profileResource';
/**
 * ホットライン利用者かどうかを判定する
 * @description useAuthentication に指定する条件
 */
export const hotlineProAuthOptions = {
    // PROFFITの利用権限がある
    isCanUseProffit: true,
    // 管理者ユーザーであれば常に表示を許可する
    isForceAdmin: true,
    // フリーコンサルタントでない
    isFreeProfessional: false,
    // 仮登録のコンサルタントでない
    isPreProfessional: false,
};
/**
 * ホットラインが利用可能な企業ユーザーかどうかを判定する
 */
export const canUseHotlineProUser = (profile, auth) => 
// PROFFITの利用権限がある
isCanUseProfessionalProffit(profile) &&
    // フリーコンサルタントでない
    !isProfessionalPreStatus(profile) &&
    // 仮登録のコンサルタントでない
    !isFreeProfessional(auth);
